export var Selection;
(function (Selection) {
    function getCursor(selection) {
        return selection.direction == "backward" ? selection.start : selection.end;
    }
    Selection.getCursor = getCursor;
    function getStalker(selection) {
        return selection.direction != "backward" ? selection.start : selection.end;
    }
    Selection.getStalker = getStalker;
})(Selection || (Selection = {}));
//# sourceMappingURL=Selection.js.map